import { useEffect, useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { Save, BookOpen, Info } from "lucide-react";
import { api, errMsg } from "@/lib/api";

export default function ContentTab() {
  const qc = useQueryClient();
  const { data: settings } = useQuery({
    queryKey: ["settings-public"],
    queryFn: async () => (await api.get("/settings/public")).data,
  });
  const [form, setForm] = useState(null);

  useEffect(() => {
    if (settings && !form) {
      setForm({
        regolamento: settings.content?.regolamento || "",
        crediti: settings.content?.crediti || "",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settings]);

  if (!form) return null;

  const save = async () => {
    try {
      await api.put("/admin/content", form);
      toast.success("Contenuti aggiornati");
      qc.invalidateQueries({ queryKey: ["settings-public"] });
    } catch (e) {
      toast.error(errMsg(e, "Salvataggio fallito"));
    }
  };

  const labelCls = "font-body-sport text-[10px] font-bold tracking-widest text-gray-500 uppercase flex items-center gap-2";
  const areaCls =
    "w-full rounded-lg bg-[#121214] border border-[#3F3F4C] px-3 py-2 text-sm text-white placeholder:text-gray-600 focus:outline-none focus:border-[#FF1E27] transition-colors font-body-sport";

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4">
      <div className="rounded-xl border border-[#3F3F4C] bg-[#2A2A32] p-5 space-y-3">
        <label className={labelCls}>
          <BookOpen className="w-4 h-4 text-[#FFB703]" /> Regolamento Ufficiale — Note aggiuntive
        </label>
        <p className="text-[11px] text-gray-500">
          Questo testo appare in cima alla pagina "Regolamento & Guida al Gioco" e può essere aggiornato in qualsiasi momento.
        </p>
        <textarea
          data-testid="content-regolamento-input"
          className={areaCls}
          rows={10}
          placeholder="Es. Variazioni regolamento 69° edizione, premi, orari prove e gara..."
          value={form.regolamento}
          onChange={(e) => setForm({ ...form, regolamento: e.target.value })}
        />
      </div>

      <div className="rounded-xl border border-[#3F3F4C] bg-[#2A2A32] p-5 space-y-3">
        <label className={labelCls}>
          <Info className="w-4 h-4 text-[#FFB703]" /> Crediti & Info App (modal footer)
        </label>
        <p className="text-[11px] text-gray-500">
          Contenuto libero della modal "Crediti App": sviluppatori, ringraziamenti, partner tecnologici.
        </p>
        <textarea
          data-testid="content-crediti-input"
          className={areaCls}
          rows={10}
          placeholder="Sviluppato da Dinamika APS in collaborazione con..."
          value={form.crediti}
          onChange={(e) => setForm({ ...form, crediti: e.target.value })}
        />
      </div>

      <div className="lg:col-span-2">
        <button
          data-testid="content-save-button"
          onClick={save}
          className="flex items-center gap-2 rounded-lg bg-[#FF1E27] hover:bg-[#CC1118] transition-colors px-5 py-2.5 min-h-[48px] font-racing font-bold text-xs tracking-widest text-white uppercase"
        >
          <Save className="w-4 h-4" /> Salva Contenuti
        </button>
      </div>
    </div>
  );
}
